import { render, staticRenderFns } from "./common-upload.vue?vue&type=template&id=61697916&scoped=true&"
import script from "./common-upload.vue?vue&type=script&lang=js&"
export * from "./common-upload.vue?vue&type=script&lang=js&"
import style0 from "./common-upload.vue?vue&type=style&index=0&id=61697916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61697916",
  null
  
)

export default component.exports